//
// Note: Organization lookupData is loaded by context
//

module.exports = function LookupData()
{
    this.tags = [];
    this.kitchenStationProfiles = [];
    this.priceBands = [];
}